// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"431915f1","580":"cbdea601"}[chunkId] + ".chunk.js";
};